import type { RouteDataSource } from '../../domain/route'
import type { RouteRepository } from '../../application/RouteRepository'
import { createFixtureRoutePlanning } from './fixtureRoutePlanning'

const fixtureRoutes = [
  { id: 'route-1', nom: 'Route 1 — Lafontaine', couleur: '#2563eb' },
  { id: 'route-2', nom: 'Route 2 — Bellefeuille', couleur: '#16a34a' },
  { id: 'route-3', nom: 'Route 3 — Saint-Antoine', couleur: '#d97706' },
]

const fixtureLocations = [
  {
    contractId: 'contract-1',
    contractNumber: 'CTR-000101',
    clientDisplayName: 'Jean Tremblay',
    serviceLocationId: 'loc-1a',
    formattedAddress: '12 rue des Érables, Saint-Jérôme',
    latitude: 45.78,
    longitude: -74.0,
    ordre: 1,
  },
  {
    contractId: 'contract-1',
    contractNumber: 'CTR-000101',
    clientDisplayName: 'Jean Tremblay',
    serviceLocationId: 'loc-1b',
    formattedAddress: '45 chemin du Lac, Saint-Jérôme',
    latitude: 45.79,
    longitude: -74.01,
    ordre: 2,
  },
  {
    contractId: 'contract-2',
    contractNumber: 'CTR-000102',
    clientDisplayName: 'Entreprises Boisvert',
    serviceLocationId: 'loc-2a',
    formattedAddress: '88 boulevard Industriel, Bellefeuille',
    latitude: 45.8,
    longitude: -74.02,
    ordre: 1,
  },
]

export function createFixtureRouteRepository(source: RouteDataSource = 'fixtures'): RouteRepository {
  return {
    ...createFixtureRoutePlanning(source),
    listActiveRoutes() {
      return Promise.resolve({
        routes: fixtureRoutes,
        meta: { source, retrievedAt: new Date().toISOString() },
      })
    },
    listUnassignedServiceLocations() {
      return Promise.resolve({
        locations: fixtureLocations,
        meta: { source, retrievedAt: new Date().toISOString() },
      })
    },
    assignServiceLocationToRoute() {
      // Fixture : aucune mutation persistée, seulement pour le mode hors-ligne/démo.
      return Promise.resolve()
    },
    generateMissionFromRoute() {
      return Promise.resolve({ missionId: 'fixture-mission-1' })
    },
  }
}
